"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PORTAL_SCOPES_TO_CHECK = exports.ACCOUNT_NAME_MAX_LENGTH = exports.ACCOUNT_NAME = void 0;
var ACCOUNT_NAME = 'accountName';
exports.ACCOUNT_NAME = ACCOUNT_NAME;
var ACCOUNT_NAME_MAX_LENGTH = 25;
exports.ACCOUNT_NAME_MAX_LENGTH = ACCOUNT_NAME_MAX_LENGTH;
var PORTAL_SCOPES_TO_CHECK = ['content-settings-access', 'sitemaps-read', 'blog-access'];
exports.PORTAL_SCOPES_TO_CHECK = PORTAL_SCOPES_TO_CHECK;